
import React, { useEffect } from 'react';
import ImageCollage from './ImageCollage';
import InfoBar from './InfoBar';

const HeroImage = () => {
  useEffect(() => {
    // Consolidated preload logic for critical images
    const imagesToPreload = [
      '/lovable-uploads/collage-image-combined.png',
      '/lovable-uploads/085d6c6c-f487-443d-b214-d88c6b2f56a3.png',
      '/lovable-uploads/f042036e-4444-4e68-9c2b-c762c22f6edb.png',
      '/lovable-uploads/1b5aadfd-c57e-465e-baea-d76bce605534.png'
    ];
    
    const preloads = imagesToPreload.map(src => {
      const linkPreload = document.createElement('link');
      linkPreload.rel = 'preload';
      linkPreload.as = 'image';
      linkPreload.href = src;
      document.head.appendChild(linkPreload);
      return linkPreload;
    });

    // Cleanup function
    return () => {
      preloads.forEach(link => {
        if (document.head.contains(link)) {
          document.head.removeChild(link);
        }
      });
    };
  }, []);

  return (
    <div className="lg:flex justify-center items-center hidden">
      <div className="relative w-full max-w-xl">
        <ImageCollage />
        <InfoBar />
      </div>
    </div>
  );
};

export default HeroImage;
